import { cn } from "@dalmatech/ui"

const card = cn(
  "flex md:w-[36.75rem] w-full flex-col gap-5 rounded-2xl border border-neutral-200 bg-white p-5 md:p-6 shadow-sm transition-shadow "
)
const cardCollapsed = cn("h-[4.75rem] min-h-[4.75rem] md:h-[88px] md:min-h-[88px]")
const headerWrapper = cn("flex md:w-[33.75rem] w-full items-center md:h-[40px] h-[36px] justify-between md:gap-5 gap-3")
const header = cn(
  "flex w-full cursor-pointer items-center gap-3 rounded-xl md:h-[40px] text-left"
)
const headerIcon = cn("flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl")
const headerContent = cn("flex min-w-0 flex-1 items-center justify-between gap-2")
const title = cn("truncate text-black text-[14px] font-bold font-buenosAires")
const chevron = cn("h-5 w-5 shrink-0 text-neutral-700")
const details = cn("flex flex-col gap-2 ")
const detailRow = cn("flex items-center justify-between gap-2")
const detailLabel = cn("text-[#776E77] text-[14px] font-semibold font-buenosAires")
const detailValue = cn(" text-black text-right text-[14px] font-bold font-buenosAires")
const modifierButtonWrapper = cn("flex flex-wrap items-center justify-center gap-3 pt-2 w-full")
const modifierButton = cn(
  "flex-1 min-w-0 rounded-full bg-neutral-100 px-6 py-2.5 text-sm font-semibold text-neutral-700 transition-colors hover:bg-neutral-200"
)
const deleteButton = cn(
  "flex-1 min-w-0 rounded-full bg-neutral-100 px-6 py-2.5 text-sm font-semibold text-neutral-700 transition-colors hover:bg-neutral-200"
)
const breedSkeleton = cn("h-5 w-32 rounded-md")

export { breedSkeleton, card, cardCollapsed, chevron, deleteButton, detailLabel, detailRow, detailValue, details, header, headerContent, headerIcon, headerWrapper, modifierButton, modifierButtonWrapper, title }

